import type { RoleViewExtension as RoleViewModel } from 'tio-data/data/resources/role-view.ext';
import type { Company as CompanyModel } from 'tio-data/data/resources/company.type';

/**
 * Relationship types that may view partner reporting.
 */
export const REPORTING_ROLES = ['TIO_ADMIN', 'EMPLOYEE_ADMIN', 'ACCOUNT_OWNER'];

/**
 * The company whose data the reporting subtree is scoped to.
 *
 * Deliberately narrower than `sessionContext.currentRole?.company`: entry is
 * granted on *any* allowed active role, but `currentRole` may be a different,
 * company-less one, which previously left every report querying an undefined
 * company id. Only allowed roles are considered — falling back to any
 * company-bearing role would scope reports to a company the session holds a
 * non-reporting role at.
 *
 * @param activeRoles the session's active roles
 * @returns the company to scope reports to, or undefined when reporting is not viewable
 */
export function reportingCompany(activeRoles: RoleViewModel[]): CompanyModel | undefined {
  return activeRoles.find(
    (role) => REPORTING_ROLES.includes(role.relationshipType) && role.company?.id
  )?.company;
}
